import Vue from "vue";
import Router from "vue-router";
import axios from "axios";
import store from "./store";

Vue.use(Router);
let router = new Router({
  mode: "history",
  routes: [
    {
          path: "/",
          name: "login",
          meta: {
            requiresAuth: false,
          },
          component: () => import("./views/Login"),
        },
        {
          path: "/dashboard",
          props: true,
          component: () => import("./layout/BaseLayout"),
          meta: {
            requiresAuth: true,
            isSuperAdmin: true,
            isCPresident: true,
            isAspirant: true,
            isUser: true,
            

          },
          children: [
            //SuperAdmin
            {
              path: "/Menu",
              name: "MenuManagement",
              meta: {
                requiresAuth: true,
                  isSuperAdmin: false,
                  isCPresident: false,
                  isAspirant: false,
                isUser: false,
              },
              component: () => import("./views/SuperAdmin/MenuManagement"),
            },
            {
              path: "/Add",
              name: "MenuMaster",
              meta: {
                requiresAuth: true,
                isSuperAdmin: true,
                isCPresident: false,
                isAspirant: false,
                isUser: false,

              },
              component: () => import("./views/SuperAdmin/MenuMaster"),
            }, 
            {
              path: "/home",
              name: "home",
              meta: {
                requiresAuth: true,
                isSuperAdmin: true,
                isCPresident: false,
                isAspirant: false,
                isUser: false,
              },
              component: () => import("./views/Dashboards/home"),
            },
            {
              path: "/ElectionType",
              name: "ElectionType",
              meta: {
                requiresAuth: true,
                isSuperAdmin: true,
                isCPresident: false,
                isAspirant: false,
                isUser: false,
              },
              component: () => import("./views/SuperAdmin/ElectionType"),
            },
            {
              path: "/PoliticalParty",
              name: "PoliticalParty",
              meta: {
                requiresAuth: true,
                isSuperAdmin: true,
                isCPresident: false,
                isAspirant: false,
                isUser: false,
              },
              component: () => import("./views/SuperAdmin/PoliticalParty"),
            },
            {
              path: "/addConstituencyPresident",
              name: "addConstituencyPresident",
              meta: {
                requiresAuth: true,
                isSuperAdmin: true,
                isCPresident: false,
                isAspirant: false,
                isUser: false,
              },
              component: () => import("./views/SuperAdmin/addConstituencyPresident"),
            },
            // {
            //   path: "/addCandidate",
            //   name: "addCandidate",
            //   meta: {
            //     requiresAuth: true,
            //     isSuperAdmin: true,
            //     isCPresident: false,
            //     isAspirant: false,
            //     isUser: false,
            //   },
            //   component: () => import("./views/SuperAdmin/addCandidate"),
            // },
              {
              path: "/CandidateAspirants",
              name: "CandidateAspirants",
              meta: {
                requiresAuth: true,
                isSuperAdmin: true,
                isCPresident: false,
                isAspirant: false,
                isUser: false,
              },
              component: () => import("./views/SuperAdmin/CandidateAspirants"),
            },
            {
              path: "/PresidentDashboard",
              name: "PresidentDashboard",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isCPresident: true,
                isAspirant: false,
                isUser: false,
              },
              component: () => import("./views/Dashboards/PresidentDashboard"),
            },

            {
              path: "/CandidateDashboard",
              name: "CandidateDashboard",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isCPresident: false,
                isAspirant: true,
                isUser: false,
              },
              component: () => import("./views/Dashboards/CandidateDashboard"),
            },
            {
              path: "/UserDashboard",
              name: "UserDashboard",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isCPresident: false,
                isAspirant: false,
                isUser: true,
              },
              component: () => import("./views/Dashboards/UserDashboard"),
            },
            {
              path: "/boothPresident",
              name: "boothPresident",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isCPresident: true,
                isAspirant: true,
                isUser: true,

              },
              component: () => import("./views/Candidate/boothPresident"),
            },
            {
              path: "/boothAgent",
              name: "boothAgent",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isCPresident: true,
                isAspirant: true,
                isUser: true,

              },
              component: () => import("./views/Candidate/boothAgent"),
            },
            {
              path: "/userProfile",
              name: "userProfile",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isCPresident: true,
                isAspirant: true,
                isUser: true,

                // isStaff: false,
              },
              component: () => import("./views/Candidate/userProfile"),
            },
            {
              path: "/addConstituency",
              name: "addConstituency",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isCPresident: true,
                isAspirant: true,
                isUser: true,

              },
              component: () => import("./views/SuperAdmin/Constituencies"),
            },
            // {
            //   path: "/addPanchayat",
            //   name: "addPanchayat",
            //   meta: {
            //     requiresAuth: true,
            //     isSuperAdmin: false,
            //     isCPresident: true,
            //     isAspirant: true,
            //     isUser: true,

            //   },
            //   component: () => import("./views/SuperAdmin/addPanchayat"),
            // },
            // {
            //   path: "/addWard",
            //   name: "addWard",
            //   meta: {
            //     requiresAuth: true,
            //     isSuperAdmin: false,
            //     isCPresident: true,
            //     isAspirant: true,
            //     isUser: true,

            //   },
            //   component: () => import("./views/SuperAdmin/addWard"),
            // },
            {
              path: "/addBooth",
              name: "addBooth",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isCPresident: true,
                isAspirant: true,
                isUser: true,

              },
              component: () => import("./views/Candidate/addBooth"),
            },
            {
              path: "/BoothList",
              name: "BoothList",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isCPresident: true,
                isAspirant: true,
                isUser: true,

              },
              component: () => import("./views/SuperAdmin/BoothList"),
            },
            {
              path: "/addVoters",
              name: "addVoters",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isCPresident: true,
                isAspirant: true,
                isUser: true,

              },
              component: () => import("./views/Candidate/addVoters"),
            },
            {
              path: "/VotersList",
              name: "VotersList",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isCPresident: true,
                isAspirant: true,
                isUser: true,

              },
              component: () => import("./views/SuperAdmin/VotersList"),
            },
            {
              path: "/test",
              name: "test",
              meta: {
                requiresAuth: true,
                isSuperAdmin: false,
                isCPresident: true,
                isAspirant: true,
                isUser: true,

              },
              component: () => import("./views/Candidate/test"),
            },
          ],
        },
        
    {
      path: "/servererror",
      name: "500",
      props: true,
      component: () => import("./common/500"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "*",
      name: "404pagenotfound",
      props: true,
      component: () => import("./common/404"),
      meta: {
        requiresAuth: false,
      },
    },
  ],
  scrollBehavior() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0;
  },
});
router.beforeEach((to, from, next) => {
  //new lines
  localStorage.setItem("PRE", from.path);
  if (store.state.isLoggedIn == true || to.matched.some(route => route.meta.requiresAuth == true)) {
    axios({
            method: 'POST',
            url: '/validate/token',
            headers: {
                'x-auth-token': localStorage.getItem('token')
            }
        }).then(response => {
            if (!response.data.status) {
              console.log("router logiut")
                          localStorage.clear();
                          router.push("/");
                          // this.$store.commit("logoutUser", true);
                return
            }
        })
        .catch(err => {
            var msg = err;
            console.log(msg)
        });
}
  // end  of newely added lines
  if (
    to.matched.some((route) => route.meta.requiresAuth == true) &&
    store.state.isLoggedIn == false
  ) {
    // console.log(from);
    next({ name: "login", params: { lastPage: from } });
    return;
  } 
  
 
  if (
    to.name == "login" &&
    store.state.isLoggedIn == true &&
    localStorage.getItem("role") == "SuperAdmin"
  ) {
    next({ name: "home" });
    return;
  }

  if (
    to.name == "login" &&
    store.state.isLoggedIn == true &&
    localStorage.getItem("role") == "ConstituencyPresident"
  ) {
    next({ name: "PresidentDashboard" });
    return;
  }
  if (
    to.name == "login" &&
    store.state.isLoggedIn == true &&
    localStorage.getItem("role") == "Aspirant"
  ) {
    next({ name: "CandidateDashboard" });
    return;
  }
  if (
    to.name == "login" &&
    store.state.isLoggedIn == true &&
    localStorage.getItem("role") == "BoothPresident" 
  ) {
    next({ name: "UserDashboard" });
    return;
  }
  if (
    to.name == "login" &&
    store.state.isLoggedIn == true &&
    localStorage.getItem("role") == "BoothAgent" 
  ) {
    next({ name: "UserDashboard" });
    return;
  }
  //
  // if (
  //   to.name == "login" &&
  //   store.state.isLoggedIn == true &&
  //   localStorage.getItem("role") == "Rajyasabha User" 
  // ) {
  //   next({ name: "UserDashboard" });
  //   return;
  // }
  // if (
  //   to.name == "login" &&
  //   store.state.isLoggedIn == true &&
  //   localStorage.getItem("role") == "Loksabha User" 
  // ) {
  //   next({ name: "UserDashboard" });
  //   return;
  // }if (
  //   to.name == "login" &&
  //   store.state.isLoggedIn == true &&
  //   localStorage.getItem("role") == "Panchayat User" 
  // ) {
  //   next({ name: "UserDashboard" });
  //   return;
  // }if (
  //   to.name == "login" &&
  //   store.state.isLoggedIn == true &&
  //   localStorage.getItem("role") == "Ward User" 
  // ) {
  //   next({ name: "UserDashboard" });
  //   return;
  // }if (
  //   to.name == "login" &&
  //   store.state.isLoggedIn == true &&
  //   localStorage.getItem("role") == "Booth User" 
  // ) {
  //   next({ name: "UserDashboard" });
  //   return;
  // }
  
// Redirection userwise
if (
  to.matched.some((route) => route.meta.isSuperAdmin == false) && from.name != "login" &&
  store.state.isLoggedIn == true && store.state.role == 'SuperAdmin'
) {
  next({ name: "home" });
  return;
}
if (
  to.matched.some((route) => route.meta.isCPresident == false) && from.name != "login" &&
  store.state.isLoggedIn == true && store.state.role == 'ConstituencyPresident'
) {
  next({ name: "PresidentDashboard" });
  return;
}
if (
  to.matched.some((route) => route.meta.isAspirant == false) && from.name != "login" &&
  store.state.isLoggedIn == true && store.state.role == 'Aspirant'
) {
  next({ name: "CandidateDashboard" });
  return;
}
if (
  to.matched.some((route) => route.meta.isBoothAgent == false) && from.name != "login" &&
  store.state.isLoggedIn == true && store.state.userType == 'BoothPresident'
) {
  next({ name: "UserDashboard" });
  return;
}
if (
  to.matched.some((route) => route.meta.isBoothAgent == false) && from.name != "login" &&
  store.state.isLoggedIn == true && store.state.userType == 'BoothAgent'
) {
  next({ name: "UserDashboard" });
  return;
}


  next();
});

export default router;
